import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { ExpiringContractsResponse } from "../../../types/contractDashboard";
import styles from "./expiringContractsTable.module.scss";

interface ExpiringContractsTableProps {
  data: ExpiringContractsResponse;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const ExpiringContractsTable: React.FC<ExpiringContractsTableProps> = ({
  data,
  currentPage,
  onPageChange,
}) => {
  const { summary, contracts } = data;
  const limit = 5;
  const totalContracts = contracts.length;
  const totalPages = Math.ceil(totalContracts / limit);
  const startIndex = (currentPage - 1) * limit + 1;
  const endIndex = Math.min(currentPage * limit, totalContracts);

  return (
    <Box className={styles.container}>
      <Box className={styles.titleSection}>
        <Typography variant="h6" className={styles.title}>
          {summary.title}
        </Typography>
        <Typography variant="body2" className={styles.subtitle}>
          {summary.urgent_message}
        </Typography>
        <Box className={styles.totalValue}>
          <Typography variant="body2" className={styles.totalLabel}>
            Total Value at Risk:
          </Typography>
          <Typography variant="h6" className={styles.totalAmount}>
            ${summary.total_value_at_risk.toLocaleString()}
          </Typography>
        </Box>
      </Box>

      <TableContainer component={Paper} className={styles.tableContainer}>
        <Table className={styles.table}>
          <TableHead>
            <TableRow className={styles.headerRow}>
              <TableCell className={styles.headerCell}>Contract Name</TableCell>
              <TableCell className={styles.headerCell}>Status</TableCell>
              <TableCell className={styles.headerCell}>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contracts.map((contract) => (
              <TableRow key={contract.id} className={styles.dataRow}>
                <TableCell className={styles.dataCell}>
                  {contract.contract_name}
                </TableCell>
                <TableCell className={styles.dataCell}>
                  <Box className={styles.statusCell}>
                    <FiberManualRecordIcon className={styles.statusIcon} />
                    <Typography variant="body2" className={styles.statusText}>
                      {contract.days_left}d left
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell className={styles.dataCell}>
                  ${contract.value.toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box className={styles.paginationContainer}>
          <Typography variant="body2" className={styles.paginationText}>
            Showing {startIndex}-{endIndex} of {totalContracts} results
          </Typography>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(_, page) => onPageChange(page)}
            size="small"
            className={styles.pagination}
          />
        </Box>
      </TableContainer>
    </Box>
  );
};

export default ExpiringContractsTable;

